// js/config.js
// Environment configuration for the application

// Get environment variables (Vite automatically loads .env files)
const config = {
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL,
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY
  },
  
  // Development mode check
  isDevelopment: import.meta.env.DEV,
  
  // Production mode check
  isProduction: import.meta.env.PROD,
  
  // API endpoints (if you add any)
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'https://api.madewithvibe.com'
  },
  
  // App configuration
  app: {
    name: 'madewithvibe',
    version: '1.0.0',
    description: 'A showcase of vibe-coded projects'
  }
}

// Validate required environment variables
function validateConfig() {
  const required = [
    'VITE_SUPABASE_URL',
    'VITE_SUPABASE_ANON_KEY'
  ]
  
  const missing = required.filter(key => !import.meta.env[key])
  
  if (missing.length > 0) {
    console.error('Missing required environment variables:', missing)
    console.error('Please check your .env file and ensure all required variables are set')
    
    if (config.isProduction) {
      throw new Error(`Missing required environment variables: ${missing.join(', ')}`)
    }
  }
}

// Validate configuration on import
validateConfig()

export default config